export async function setNodeStyle(nodes, transform) {
    await this.execute(
        () => this.actions.setNodeStyle(nodes, transform)
    )
}
